import { atom } from "recoil";

export interface Auth {
  id: Number;
  user_name: String;
  token: string;
}

export const authState = atom({
  key: "authState",
  default: null,
});
